import React, { useState, useEffect } from 'react';
import styles from './sections.module.css';
import { publicSiteAPI } from '../../../services/api';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface FAQSectionProps {
  slug: string;
}

export const FAQSection: React.FC<FAQSectionProps> = ({ slug }) => {
  const ref = useScrollReveal();
  const [questions, setQuestions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    loadFaq();
  }, [slug]);

  const loadFaq = async () => {
    try {
      const data = await publicSiteAPI.getFaq(slug);
      setQuestions(data || []);
    } catch {
      // silent fail
    } finally {
      setLoading(false);
    }
  };

  if (loading || questions.length === 0) return null;

  return (
    <section id="faq" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Veelgestelde vragen</h2>
        <div className={styles.faqList}>
          {questions.map((q: any, i: number) => {
            const isOpen = openIndex === i;
            const answerContent = typeof q.answer === 'string' ? q.answer : q.answer?.content;

            return (
              <div key={q._id || i} className={`${styles.faqItem} ${isOpen ? styles.faqOpen : ''}`}>
                <button
                  className={styles.faqQuestion}
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                >
                  <span>{q.question}</span>
                  <svg
                    className={styles.faqChevron}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                <div className={styles.faqAnswer}>
                  <div className={styles.faqAnswerInner}>
                    {answerContent && <p>{answerContent}</p>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
